import {MessagingService} from './shared/events/messaging-service';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {ModalModule} from 'ngx-bootstrap/modal';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {ApiModule, Configuration, ConfigurationParameters} from '../gen/swagger-api';
import {AppComponent} from './app.component';
import {MainPageComponent} from './achelos-iot/main-page/main-page.component';
import {LoginPageComponent} from './achelos-iot/login-page/login-page.component';
import {AlertComponent} from './shared/directives/alert/alert.component';
import {LoadSubscriptionModalComponent} from './achelos-iot/modals/load-subscription/load-subscription-modal.component';
import {SortableColumnComponent} from './shared/directives/sortable-column/sortable-column.component';
import {SortableTableDirective} from './shared/directives/sortable-table.directive';
import {FilterPipe} from './shared/pipes/filter.pipe';
import {CreateNewGroupModalComponent} from './achelos-iot/modals/create-new-group/create-new-group-modal.component';
import {RequestForNewPoolModalComponent} from './achelos-iot/modals/request-for-new-pool/request-for-new-pool-modal.component';
import {UpdateConnectivityParametersModalComponent} from './achelos-iot/modals/update-connectivity-parameters/update-connectivity-parameters-modal.component';
import {GenericOperationModalComponent} from './achelos-iot/modals/generic-operation/generic-operation-modal.component';
import {CardDetailsModalComponent} from './achelos-iot/modals/card-details/card-details-modal.component';
import {AppRoutingModule} from './app-routing.module';
import {AlertService} from './shared/services/alert.service';
import {SubscriptionService} from './shared/services/subscription.service';
import {ColumnSortService} from './shared/services/column-sort.service';
import {AuthService} from './shared/services/auth/auth.service';
import {ErrorMapperService} from './shared/services/error-mapper.service';
import {AuthGuardService} from './shared/services/auth/auth-guard.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from './shared/interceptors/auth.interceptor';
import {AmplifyAngularModule, AmplifyService} from 'aws-amplify-angular';
import {SuccessModalComponent} from './achelos-iot/modals/success-modal/success-modal.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {AuditModalComponent} from './achelos-iot/modals/audit-modal/audit-modal.component';
import {HistoryModalComponent} from './achelos-iot/modals/history-modal/history-modal.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ApiModuleForGetCards} from './shared/services/workaround/api.module';
import {NewPasswordModalComponent} from './achelos-iot/modals/new-password-modal/new-password-modal.component';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {HTTPStatus, LoaderInterceptor} from './shared/interceptors/loader.interceptor';
import {NgxPaginationModule} from 'ngx-pagination';
import {ErrorModalComponent} from './achelos-iot/modals/error-modal/error-modal.component';
import {HttpOperationsService} from './shared/services/http-operations.service';
import {TableHeaderSearchModalComponent} from './achelos-iot/modals/table-header-search-modal/table-header-search-modal.component';
import {SelectMsisdnComponent} from './achelos-iot/modals/select-msisdn/select-msisdn.component';
import {PoolPropertiesComponent} from './achelos-iot/modals/pool-properties/pool-properties.component';
import {SubscriptionPoolsPageComponent} from './achelos-iot/subscription-pools-page/subscription-pools-page.component';
import {CardGroupsComponent} from './achelos-iot/card-groups/card-groups.component';
import {SubscriptionPoolMnoAuditComponent} from './achelos-iot/modals/subscription-pool-mno-audit/subscription-pool-mno-audit.component';
import {DeleteQuestionModalComponent} from './achelos-iot/modals/delete-question-modal/delete-question-modal.component';
import {SelectionOperationModalComponent} from './achelos-iot/modals/selection-operation-modal/selection-operation-modal.component';
import {NavHeaderComponent} from './achelos-iot/shared/nav-header/nav-header.component';
import {CallbackModalComponent} from './achelos-iot/modals/callback-modal/callback-modal.component';
import {ImportCardsModalComponent} from './achelos-iot/modals/import-cards-modal/import-cards-modal.component';
import {ImportFileService} from './shared/services/import-file.service';
import {ScDeleteCardsModalComponent} from './achelos-iot/modals/sc-delete-cards-modal/sc-delete-cards-modal.component';
import {ImportProgressModalComponent} from './achelos-iot/modals/import-progress-modal/import-progress-modal.component';
import {ErrorHandlingService} from './shared/services/error-handling-service';
import {DefaultService} from "../gen/swagger-api/api/default.service";
import {UserManagementComponent} from "./achelos-iot/user-management/user-management.component";
import { AddNewUserPermissionComponent } from './achelos-iot/modals/add-new-user-permission/add-new-user-permission.component';
import {MoveProfilesModalComponent} from "./achelos-iot/modals/move-profiles/move-profiles-modal.component";
import {InfoModalComponent} from './achelos-iot/modals/info-modal/info-modal.component';
import {ConfirmDialogComponent} from './achelos-iot/modals/confirm-dialog/confirm-dialog.component';
import { OperationInfoComponent } from './achelos-iot/operation-info/operation-info.component';
import { OperationInfoViewComponent } from './achelos-iot/operation-info-view/operation-info-view.component';

export function apiConfigFactory(): Configuration {

  const params: ConfigurationParameters = {
    basePath: '[PLACEHOLDER]',
    withCredentials: true
  };
  return new Configuration(params);
}


@NgModule({
  declarations: [
    AppComponent,
    MainPageComponent,
    LoginPageComponent,
    AlertComponent,
    LoadSubscriptionModalComponent,
    SortableColumnComponent,
    SortableTableDirective,
    FilterPipe,
    SelectionOperationModalComponent,
    MoveProfilesModalComponent,
    CreateNewGroupModalComponent,
    ImportProgressModalComponent,
    DeleteQuestionModalComponent,
    RequestForNewPoolModalComponent,
    UpdateConnectivityParametersModalComponent,
    GenericOperationModalComponent,
    ImportCardsModalComponent,
    CardDetailsModalComponent,
    SuccessModalComponent,
    AuditModalComponent,
    HistoryModalComponent,
    NewPasswordModalComponent,
    ErrorModalComponent,
    ScDeleteCardsModalComponent,
    TableHeaderSearchModalComponent,
    SelectMsisdnComponent,
    PoolPropertiesComponent,
    SubscriptionPoolsPageComponent,
    UserManagementComponent,
    SubscriptionPoolMnoAuditComponent,
    CardGroupsComponent,
    NavHeaderComponent,
    CallbackModalComponent,
    AddNewUserPermissionComponent,
    InfoModalComponent,
    ConfirmDialogComponent,
    OperationInfoComponent,
    OperationInfoViewComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    ApiModule.forRoot(apiConfigFactory),
    AmplifyAngularModule,
    ApiModuleForGetCards.forRoot(apiConfigFactory),
    InfiniteScrollModule,
    NgxPaginationModule,
    TypeaheadModule.forRoot()
  ],
  providers: [
    AuthService,
    AlertService,
    AuthGuardService,
    ImportFileService,
    ErrorHandlingService,
    SubscriptionService,
    DefaultService,
    // CardPoolsService,
    ColumnSortService,
    AmplifyService,
    ErrorMapperService,
    HTTPStatus,
    HttpOperationsService,
    MessagingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
  exports: [],
  entryComponents: [
    LoadSubscriptionModalComponent,
    UpdateConnectivityParametersModalComponent,
    GenericOperationModalComponent,
    RequestForNewPoolModalComponent,
    CardDetailsModalComponent,
    SuccessModalComponent,
    TableHeaderSearchModalComponent,
    ScDeleteCardsModalComponent,
    AuditModalComponent,
    HistoryModalComponent,
    ImportProgressModalComponent,
    DeleteQuestionModalComponent,
    NewPasswordModalComponent,
    ErrorModalComponent,
    ImportCardsModalComponent,
    SelectMsisdnComponent,
    PoolPropertiesComponent,
    SelectionOperationModalComponent,
    MoveProfilesModalComponent,
    SubscriptionPoolMnoAuditComponent,
    CallbackModalComponent,
    AddNewUserPermissionComponent,
    InfoModalComponent,
    ConfirmDialogComponent
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts